export default __webpack_public_path__ + "static/media/heroIllustration.7fc3a17b.png";